export const arrayMerge = (array) => {
  const defaultValues = [{value: '', label: 'select'}];
  const newArray =[...defaultValues, ...array]
  return newArray
}; 